<template>
    <div class="p-3">
        <b-card
            title="Edit Kuota Poli"
        >
            <b-card-text>
                <p class="mt-3">Notes:</p>
                <p>
                    - Jadwal dokter dan kuota poli yang bisa ditambah atau dirubah adalah jadwal dokter dan kuota poli hanya untuk pasien kategori Umum (jadwal dokter internal) saja<br>
                    - Untuk penambahan dan perubahan jadwal dokter dan kuota poli untuk kategori BPJS silahkan melakukan perubahan di HFIS karena akan berpengaruh pada pembuatan SEP
                </p>

                <div class="mt-3">
                    <b-button variant="primary" size="sm" @click="addJadwalUmum"><i class="fa fa-plus"></i> Tambah Jadwal Dokter Umum</b-button>
                    <b-button variant="primary" size="sm" @click="updateJadwalDokterBPJS"><i class="fa fa-refresh"></i> Update Jdwal Dokter BPJS</b-button>
                    <b-button variant="danger" size="sm" @click="cancelEdit">Kembali</b-button>

                    <b-form v-if="add_new" class="mt-3">
                        <b-row>
                            <b-col md="6">
                                <div class="row mb-3">
                                    <label class="col-sm-4 col-form-label text-end" for="nama_dokter">Nama Dokter</label>
                                    <div class="col">
                                        <select2 class="form-input" v-model="form_data.kode_dokter" :options="dokter_poli_options"></select2>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <div class="row mb-3">
                                    <label class="col-sm-4 col-form-label text-end" for="hari">Hari</label>
                                    <div class="col">
                                        <select2 class="form-input" v-model="form_data.hari" :options="hari_options"></select2>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <div class="row mb-3">
                                    <label class="col-sm-4 col-form-label text-end" for="kapasitas_pasien">Kapasitas Pasien</label>
                                    <div class="col">
                                        <b-form-input type="number" id="kapasitas_pasien" v-model="form_data.kapasitas_pasien"></b-form-input>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <div class="row mb-3">
                                    <label class="col-sm-4 col-form-label text-end" for="jam_mulai">Jam Mulai</label>
                                    <div class="col">
                                        <b-form-input id="jam_mulai" v-model="form_data.jam_mulai"></b-form-input>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <div class="row mb-3">
                                    <label class="col-sm-4 col-form-label text-end" for="jam_selesai">Jam Selesai</label>
                                    <div class="col">
                                        <b-form-input id="jam_selesai" v-model="form_data.jam_selesai"></b-form-input>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-row>
                                    <b-col sm="4"></b-col>
                                    <b-col>
                                        <b-button variant="success" @click="simpanData"><i class="fa fa-save"></i> Simpan</b-button>
                                        <b-button variant="danger" @click="batalTambah"><i class="fa fa-close"></i> Batal</b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>

                <form>
                    <div class="row">
                        <div id="tabledata-kuota-poli" class="mt-3"></div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    props: ['id'],
    components: {
        Select2
    },
    data() {
        return {
            table: null,
            table_data: [],
            user: null,
            access_token: null,
            table: null,
            paging_data: {
                from: 0,
                to: 0,
                total: 0
            },
            form: {
                poli: 0,
                dokter: 0,
                kuota: 0,
            },
            form_data: {
                kode_poli: 0,
                kode_dokter: 0,
                hari: 0,
                nama_hari: '',
                kapasitas_pasien: '',
                jam_mulai: '',
                jam_selesai: '',
            },
            item_per_page: 10,
            page: 1,
            dokter_poli_options: [{id: 0, text: '--- Pilih Dokter ---'}],
            hari_options: [{id: 0, text: '--- Pilih Hari ---'}],
            nama_hari: [
                {id: 1, text: 'SENIN'},
                {id: 2, text: 'SELASA'},
                {id: 3, text: 'RABU'},
                {id: 4, text: 'KAMIS'},
                {id: 5, text: 'JUMAT'},
                {id: 6, text: 'SABTU'},
                {id: 7, text: 'MINGGU'},
            ],
            add_new: false,
        }
    },
    created() {
        this.getAuth()
        this.getDokterPoli()
        this.updateOptionHari()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getKuotaPoli()
        },
        updateOptionHari() {
            this.hari_options = [{id: 0, text: '--- Pilih Hari ---'}]
            for (let i = 0; i < this.nama_hari.length; i++) {
                const nm_hari = this.nama_hari[i];
                this.hari_options.push({id: nm_hari.id, text: nm_hari.text})
            }
        },
        getKuotaPoli() {
            this.$isLoading(true)
            let uri = '/api/konfkuotapoli/' + this.id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.table_data = response.data.konf_kuota_poli

                let tipe_jadwal = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let kode_dokter_bpjs = data.kode_dokter_bpjs

                    if (kode_dokter_bpjs) {
                        return 'BPJS dan Umum'
                    } else {
                        return 'Umum'
                    }
                }

                let jadwal_actions = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let kode_dokter_bpjs = data.kode_dokter_bpjs

                    if (!kode_dokter_bpjs) {
                        return '<a class="btn btn-success btn-sm" id="but-save"><i class="fa fa-floppy-o" aria-hidden="true" id="save"></i></a><a class="btn btn-danger btn-sm" id="but-delete"><i class="fa fa-trash" aria-hidden="true" id="delete"></i></a>'
                    }
                }

                let keterangan = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let libur = data.libur

                    return libur == 0 ? 'Buka' : 'Tutup'
                }

                this.table = new Tabulator('#tabledata-kuota-poli', {
                    layout:"fitColumns",
                    data: this.table_data[0].jadwal_dokter,
                    columns:[
                        {title: 'Tipe', formatter: tipe_jadwal, headerSort: false},
                        {title: 'Kode DPJP', field: 'kode_dokter_bpjs', headerSort: false},
                        {title: "Nama Dokter", field: "nama_dokter", headerSort: false, width: '250'},
                        {title: "Hari", field: "nama_hari", headerSort: false},
                        {title: "Kapasitas Pasien", field: "kapasitas_pasien", headerSort: false, editor: 'number'},
                        {title: "Jam Mulai", field: "jam_mulai", headerSort: false, editor: 'input'},
                        {title: "Jam Selesai", field: "jam_selesai", headerSort: false, editor: 'input'},
                        {title: "Keterangan", field: "libur", formatter: keterangan, headerSort: false, editor: 'select', editorParams: {
                            values: [
                                {value: 0, label: 'Buka'},
                                {value: 1, label: 'Tutup'},
                            ]
                        }, cellEdited: this.setKeterangan},
                        {title:  'Aksi', formatter: jadwal_actions, headerSort: false, cellClick: this.jadwalActions}
                    ]
                })

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        setKeterangan(cell) {
            this.$swal.fire({
                title: 'Perhatian! ',
                text: 'Data akan diupdate. Yakin?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, update!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = cell.getRow().getData()
                    let uri = '/api/update-keterangan-jadwal-dokter'

                    let headers = {
                        headers: {
                            Accept: 'application/json',
                            Authorization: 'Bearer ' + this.access_token
                        }
                    }

                    let data_update = {
                        id: data.id,
                        libur: data.libur
                    }

                    this.axios.post(uri, data_update, headers).then(response => {
                        if (response.data.status == 'success') {
                            this.$swal.fire({
                                title: 'Sukses!',
                                text: 'Jadwal Dokter Berhasil Diupdate!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                        } else {
                            this.$swal.fire({
                                title: 'Error!',
                                text: response.data.message,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                        }
                    })
                }
            }).catch((error) => {
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        doReset() {
            this.$router.push({ name: 'konfigurasi_kuota_poli' }).catch(()=>{})
        },
        jadwalActions(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id

            if (type == 'but-save' || type == 'save') {
                this.updateJadwalDokter(data)
            } else if (type == 'but-delete' || type == 'delete') {
                this.$swal.fire({
                    title: 'Perhatian! ',
                    text: 'Data akan dihapus. Yakin?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, hapus!',
                    cancelButtonText: 'Batal'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteJadwalDokter(data)
                    }
                }).catch((error) => {
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            }
        },
        getDokterPoli() {
            this.$isLoading(true)
            let uri = '/api/get_all_dokter_poli?poli=' + this.id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.dokter_poli_options = [{id: 0, text: '--- Pilih Dokter ---'}]

                let dokter_poli = response.data.dokters
                dokter_poli.forEach(dp => {
                    this.dokter_poli_options.push({id: dp.KdDoc, text: dp.KdDoc + ' - ' + dp.NmDoc})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        updateJadwalDokter(data) {
            this.$isLoading(true)
            let uri = '/api/update_jadwal_dokter'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, data, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Sukses!',
                        text: 'Jadwal Dokter Berhasil Diupdate!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        deleteJadwalDokter(data) {
            this.$isLoading(true)
            let uri = '/api/delete_jadwal_dokter'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, data, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Sukses!',
                        text: 'Jadwal Dokter Berhasil Diupdate!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })

                    this.getKuotaPoli()
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        addJadwalUmum() {
            this.add_new = true
        },
        simpanData() {
            let nama_hari = ''
            for (let i = 0; i < this.nama_hari.length; i++) {
                const nm_hari = this.nama_hari[i];
                if (nm_hari.id == this.form_data.hari) {
                    nama_hari = nm_hari.text
                }
            }

            this.form_data.kode_poli = this.id
            this.form_data.nama_hari = nama_hari

            let validation = this.validateInput()
            let status = validation.status
            if (status) {
                this.$isLoading(true)
                let uri = '/api/add_jadwal_dokter_umum'

                let headers = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + this.access_token
                    }
                }

                this.axios.post(uri, this.form_data, headers).then(response => {
                    if (response.data.status == 'success') {
                        this.$swal.fire({
                            title: 'Sukses!',
                            text: 'Jadwal Dokter Berhasil Ditambahkan!',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                    } else {
                        this.$swal.fire({
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }

                    this.batalTambah()
                    this.$isLoading(false)
                    this.getKuotaPoli()
                }).catch((error) => {
                    this.$isLoading(false)
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            } else {
                this.$swal.fire({
                    title: 'Error!',
                    text: validation.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
        },
        validateInput() {
            let error = ''

            if (this.form_data.kode_poli == 0) {
                error += 'Poli, '
            }
            if (this.form_data.kode_dokter == 0) {
                error += 'Dokter, '
            }
            if (this.form_data.hari == 0) {
                error += 'Hari, '
            }
            if (this.form_data.kapasitas_pasien == '') {
                error += 'Kapasitas Pasien, '
            }
            if (this.form_data.jam_mulai == '') {
                error += 'Jam Mulai, '
            }
            if (this.form_data.jam_selesai == '') {
                error += 'Jam Selesai, '
            }

            if (error != '') {
                let message = error + 'harus diisi!'
                return {
                    status: false,
                    message: message
                }
            } else {
                return {
                    status: true
                }
            }
        },
        batalTambah() {
            this.form_data.kode_dokter = 0
            this.form_data.hari = 0
            this.form_data.nama_hari = ''
            this.form_data.kapasitas_pasien = ''
            this.form_data.jam_mulai = ''
            this.form_data.jam_selesai = ''
            this.add_new = false
        },
        updateJadwalDokterBPJS() {
            this.form_data.kode_poli = this.id
            this.getKonfigurasiKuotaPoli()
        },
        getKonfigurasiKuotaPoli() {
            if (this.form_data.kode_poli > 0) {
                this.$isLoading(true)
                let query_page = this.page ? '&page=' + this.page : ''
                let uri = '/api/konfkuotapoli?per_page=' + this.item_per_page + query_page + '&search=' + this.form_data.kode_poli + '&type=create'

                let headers = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + this.access_token
                    }
                }

                this.axios.get(uri, headers).then(response => {
                    if (response.data.status == 'success') {
                        this.getDokterPoli()
                    } else {
                        this.$swal.fire({
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }

                    this.$isLoading(false)
                }).catch((error) => {
                    this.$isLoading(false)
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            }
        },
        cancelEdit() {
            this.$router.push('konfigurasi-kuota-poli')
        }
    }
}
</script>
